import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Divider = styled.hr`
  border: 0;
  border-block-end: solid 1px #e6edf2;
  margin-block-start: ${getToken('space-xs')};
  margin-block-end: ${getToken('space-xs')};
  width: 100%;
`

export default Divider
